<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pl15 pr15 pt15 pb15">
            <hos_statistics_search_from ref="search_from" @query="getForm"
                                        @writeExcel="output"></hos_statistics_search_from>
            <div class="mt15">
                <el-table border size="mini" :data="tableList" :header-cell-style="{backgroundColor:'#fafafa'}"
                          ref="table">
                    <el-table-column label="转诊类型" align="center" prop="referralType"></el-table-column>
                    <el-table-column label="统计类型" align="center" prop="statisticType"></el-table-column>
                    <el-table-column label="转诊单状态" align="center" prop="referralStatusDescription"></el-table-column>
                    <el-table-column label="姓名" align="center" prop="patName"></el-table-column>
                    <el-table-column label="性别" align="center" prop="patGender"
                                     :formatter="formateSex"></el-table-column>
                    <el-table-column label="年龄" align="center" prop="patAge"></el-table-column>
                    <el-table-column label="转诊申请日期" align="center" prop="createTime"
                                     :formatter="formateTime"></el-table-column>
                    <el-table-column label="预约日期" align="center" prop="hopeTime"
                                     :formatter="formateTime"></el-table-column>
                    <el-table-column label="申请医院" align="center" prop="initHosName"></el-table-column>
                    <el-table-column label="申请医生" align="center" prop="initDocName"></el-table-column>
                    <el-table-column label="预约医院" align="center" prop="hopeHosName"></el-table-column>
                    <el-table-column label="预约项目" align="center" prop="projectName"></el-table-column>
                    <el-table-column label="安排日期" align="center" prop="acceptTime"
                                     :formatter="formateTime"></el-table-column>
                </el-table>
            </div>
            <div class="pt15" style="text-align: center">
                <el-pagination
                        @current-change="pageChange"
                        :page-size="page.pageSize"
                        :current-page="page.pageNum"
                        layout="total, prev, pager, next, jumper"
                        :total="page.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import Breadcrumb from "../../components/common/Breadcrumb";
  import hos_statistics_search_from from "../../components/hos/hos-statistics-search-from"
  import {hosService} from '../../lib/service/hos'
  import {timeFormat} from "../../lib/hos/until";
  import {isEmpty} from "../../lib/utils";
  import XLSX from 'xlsx'

  export default {
    name: "statistics",
    components: {
      Breadcrumb, hos_statistics_search_from
    },
    data() {
      return {
        pages: [this.$route.params.type == 'check' ? '检查转诊' : '日间手术转诊', '转诊统计'],
        tableList: [],
        page: {
          pageSize: 20,
          pageNum: 1,
          total: 0
        },
        searchForm: {}
      }
    },
    methods: {
      pageChange(num) {
        this.page.pageNum = num;
        this.queryTableList();
      },
      //获取搜索条件
      getForm() {
        this.searchForm = this.$refs['search_from'].getForm();
        this.searchForm.referralType = this.$route.params.type == 'check' ? '检查转诊' : '日间手术转诊';
        this.page.pageNum = 1;
        this.page.total = 0;
        let start = this.searchForm.startTime.substring(0, 4) + this.searchForm.startTime.substring(5, 7) + this.searchForm.startTime.substring(8, 10)
        let end = this.searchForm.endTime.substring(0, 4) + this.searchForm.endTime.substring(5, 7) + this.searchForm.endTime.substring(8, 10)

        if (end < start) {
          this.$message.error('请合理选择时间范围！')
          return
        }
        this.queryTableList();
      },
      //查询表格数据
      async queryTableList() {
        this.searchForm.pageSize = this.page.pageSize;
        this.searchForm.pageNum = this.page.pageNum;
        const {list, page} = await hosService.statictics(this.searchForm);
        this.tableList = list;
        this.page.total = page.total;
      },
      //导出数据
      output() {
        if (this.tableList.length === 0) return this.$message.error('暂无数据导出');
        const table = this.$refs.table;
        if (!isEmpty(table)) {
          const {columns} = table;//列
          let data = [], propertys = [...columns].map(r => r.property);//字段
          data.push([...columns].map(r => r.label));//列头
          this.tableList.forEach(r => {
            let arr = [...propertys].map((rr) => {
              if (rr == 'patGender') {
                return r[rr] == 'F' ? '女' : '男'
              }
              if (['createTime', 'hopeTime', 'acceptTime'].indexOf(rr) != -1 && r[rr] != '' && r[rr] != undefined) {
                return timeFormat(r[rr], '%Y-%m-%d %H:%M');
              }
              return r[rr];
            });
            data.push(arr);
          });
          const ws = XLSX.utils.aoa_to_sheet(data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
          XLSX.writeFile(wb, Date.now() + ".xlsx");
        }
      },
      //性别的格式化函数
      formateSex(row, column, cellValue) {
        return cellValue == 'F' ? '女' : '男';
      },
      //时间的格式化函数
      formateTime(row, column, cellValue) {
        if (cellValue == undefined || cellValue == "") return ''
        return timeFormat(cellValue, '%Y-%m-%d %H:%M');
      }
    },
    watch: {
      $route() {
        this.pages = [this.$route.params.type == 'check' ? '检查转诊' : '日间手术转诊', '转诊统计'];
        this.getForm();
      }
    },
    mounted() {
      this.getForm();
    }
  }
</script>

<style scoped>

</style>